import { useState } from 'react'
import Image from 'next/image'
import Link from 'next/link'
import { mediumLoader } from '../utils/custom-image-loader'

const NewsRecentsGridItem = ({ obj }) => {
  const brokenImage = '/images/popshelf-broken-onwhite.svg'
  const dynamicImage = obj.dynamicMediaUrl || obj.image_url
  const [imageSrc, setImageSrc] = useState(dynamicImage || brokenImage)

  return (
    <div key={obj.url} className="news-recents__grid-item">
      <div className="news-recents__card">
        <Link href={obj.url}>
            <div className="image-next">
              <Image
                src={imageSrc}
                alt={obj.title}
                fill
                loader={mediumLoader}
                onError={() => setImageSrc(brokenImage)}
              />
            </div>
            <p className="news-recents__text">{obj.title}</p>
          </Link>
      </div>
    </div>
  )
}

const NewsRecentArticles = ({ recents }) => {
  const renderRecents = () => {
    return recents.map((obj) => {
      return <NewsRecentsGridItem obj={obj} key={obj.url} />
    })
  }
  return (
    <div className="news-recents">
      <div className="news-recents__grid">{renderRecents()}</div>
    </div>
  )
}

export default NewsRecentArticles
